<script>
    import { tour } from '../tour'
    import { fly } from 'svelte/transition';
    
    // Tooltips
    import Tooltip from './Tooltip.svelte';
    let showingTooltip = false;
    const showTooltip = () => { showingTooltip = true; }
    const hideTooltip = () => { showingTooltip = false; }

    export let nextScene = tour.nextScene;

</script>

<style>
    :root {
        --next-scene-bg-color-rgb: var(--theme-color-rgb);
    }

    div {
        background: rgba(var(--next-scene-bg-color-rgb), 0.8);
        color: white;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 999;
        border-radius: 10px 0 0 10px;
        cursor:pointer;
        padding: 20px 10px 20px 20px;
    }

    div:hover {
        background: rgba(var(--next-scene-bg-color-rgb), 1);
        border: 3px solid rgba(255,255,255,1);
        border-width: 3px 0 3px 3px;
    }

    img {
        transform: scaleX(-1);
    }    
</style>

<div class="no-select" on:click="{nextScene}" transition:fly={{x: 300, duration: 500 }} on:mouseenter={showTooltip} on:mouseleave={hideTooltip}>
    <Tooltip text="Next Location" showingTooltip={showingTooltip} position={'left'} />
    <img src="./images/direction.png" width="35" height="35" alt="Next Location"/>
</div>